import { render, staticRenderFns } from "./ToggleAlert.vue?vue&type=template&id=4bfa5b91&scoped=true"
import script from "./ToggleAlert.vue?vue&type=script&lang=ts"
export * from "./ToggleAlert.vue?vue&type=script&lang=ts"
import style0 from "./ToggleAlert.vue?vue&type=style&index=0&id=4bfa5b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa5b91",
  null
  
)

export default component.exports